import { render } from "./PlaySkeleton.vue?vue&type=template&id=b75c3044"
import script from "./PlaySkeleton.vue?vue&type=script&lang=js"
export * from "./PlaySkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__